// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import './PatientChartHeader.scss'
import moment from 'moment/moment'
import { useDispatch, useSelector } from 'react-redux'
import { Badge } from '@quickmd-llc/design-system'
import { AllergiesHoverOverPopUp, DrugScreenTag, PrimaryButton, Tooltip, IdVerificationStatusTag } from 'ui_kit_qmd'
import voidPhotoIcon from '../../../../images/management/clinicMembers/voidPhoto.png'
import errorIcon from '../../../../images/calendar/ErrorCircle.png'
import editIcon from '../../../../images/charts/Edit.png'
import {
  ALLERGIES_TEXT,
  MRN_TEXT,
  ON_HOLD_PATIENT_STATUS_TEXT,
  PREFERRED_NAME_TEXT,
  PRINT_BUTTON_TEXT,
  PRINTED_FRIENDLY_PATIENT_CHARTS,
  profilePermissions,
  STATE_TEXT,
} from '../../../../utils/constants'
import {
  getAge,
  getStateByAbbreviation,
  getTabId,
  isActiveEllipsisCheck,
  isDrugScreenTagClickable,
} from '../../../../utils/common'
import { getPatientChartPrintedVersion } from '../../../../store/charts/ChartsThunk'
import { setIsPrintedVersionReadyToBePrinted } from '../../../../store/charts/ChartsActions'
import { dateHelper, DATE_FORMAT_SLASH } from '../../../../utils/dateUtils'
import { getMediaFile } from '../../../../store/file-pop-up/FilePopUpThunk'
import { getIDVerification } from '../../../../store/id-verification-pop-up/IDVerificationPopUpThunk'
import { ProgramPlanBadge } from '@/components/program-plan-badge/ProgramPlanBadge'
import { MAIN_ACCOUNT_BADGE } from '@/pages/patient-charts/components/patientChartBadges'

export const PatientChartHeader = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  ({ selectedHoldStatus, setIsPopUpOpen, isOnHoldStatus, onOpenAllergiesPopUp }) => {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('id')
    const tabId = getTabId()
    const dispatch = useDispatch()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo?.[id])
    const isPrintVersionOfChartsReadyToBePrinted = useSelector(
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      (state) => state.chartsReducer.isPrintVersionOfChartsReadyToBePrinted,
    )
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const profile = useSelector((state) => state.accountSettings.adminProfile)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const flags = useSelector((state) => state.flags.flags)

    const isWithOnHoldPermission = profile?.Permissions?.includes(profilePermissions.ON_HOLD_PERMISSION)

    const [allergiesCountValue, setAllergiesCountValue] = useState(0)
    const [isShowNamePopUp, setIsShowNamePopUp] = useState(false)
    const [isShowAllergiesHoverOver, setIsShowAllergiesHoverOver] = useState(false)
    const [isOnHold, setIsOnHold] = useState(false)

    const isMergedAccount = patientInfo?.RestrictionStatus === 'merged'

    useEffect(() => {
      setIsOnHold(isOnHoldStatus)
    }, [isOnHoldStatus])

    useEffect(() => {
      const timer = setInterval(() => {
        isActiveEllipsisCheck('patient-chart-header-name', setIsShowNamePopUp)
      }, 1000)
      return () => clearInterval(timer)
    }, [])

    useEffect(() => {
      setAllergiesCountValue(patientInfo?.AllergyCollection?.Allergies?.length || 0)
    }, [patientInfo?.AllergyCollection?.Allergies?.length])

    useEffect(() => {
      if (isPrintVersionOfChartsReadyToBePrinted && isPrintVersionOfChartsReadyToBePrinted === id) {
        window.open(`${window.location.origin}${PRINTED_FRIENDLY_PATIENT_CHARTS}/${id}`)
        dispatch(setIsPrintedVersionReadyToBePrinted(false))
      }
    }, [dispatch, id, isPrintVersionOfChartsReadyToBePrinted])

    const onClickPrintBtn = useCallback(() => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientChartPrintedVersion(id))
    }, [dispatch, id])

    // Allergies hover
    const onMouseOverAllergies = () => setIsShowAllergiesHoverOver(true)
    const onMouseOutAllergies = () => setIsShowAllergiesHoverOver(false)
    const onClickEditAllergies = useCallback(() => {
      onOpenAllergiesPopUp(true)
    }, [])

    const onClickEditOnHoldStatus = useCallback(() => {
      setIsPopUpOpen(true)
    }, [setIsPopUpOpen])

    const getFile = useCallback(() => {
      dispatch(getMediaFile({ ...patientInfo, StateCode: patientInfo?.Address?.StateCode }, tabId))
    }, [dispatch, patientInfo, tabId])

    const getIDVerificationInfo = useCallback(() => {
      dispatch(getIDVerification(id, tabId))
    }, [dispatch, tabId])

    return (
      <div className='patient-chart-header-main-wrapper'>
        {patientInfo ?
          <>
            <div className='patient-chart-header-img-wrapper'>
              <img
                className='patient-chart-header-img'
                src={patientInfo?.ImageUrl || voidPhotoIcon}
                alt='patient-profile-image'
              />
            </div>
            <div>
              <div>
                <div className='patient-chart-header-name-gender-wrapper'>
                  <Tooltip content={`${patientInfo?.FirstName} ${patientInfo?.LastName}`} disabled={!isShowNamePopUp}>
                    <div
                      id='patient-chart-header-name'
                      className='patient-chart-header-text patient-chart-header-title patient-chart-header-name'>
                      {`${patientInfo?.FirstName} ${patientInfo?.LastName}`}
                    </div>
                  </Tooltip>
                  <div className='patient-chart-header-text patient-chart-header-title patient-chart-header-gender'>
                    (
                    {`${getAge(moment(patientInfo?.BirthDate).toString())}/${
                      patientInfo?.Gender === 'male' ? 'M' : 'F'
                    }`}
                    )
                  </div>
                </div>
              </div>
              <div className='patient-chart-header-name-id-wrapper'>
                {flags.id_verification_show_tag_admin && patientInfo?.IdentityVerification?.Status ?
                  <IdVerificationStatusTag
                    tagStatus={patientInfo.IdentityVerification.Status}
                    className='patient-chart-header-id-tag'
                    onClick={getIDVerificationInfo}
                    requestDateTime={patientInfo.IdentityVerification.RequestDateTime}
                  />
                : null}
                {patientInfo?.DrugScreen ?
                  <DrugScreenTag
                    type={patientInfo?.DrugScreen.Status}
                    completedDate={patientInfo?.DrugScreen.CompleteDate}
                    expiredDate={patientInfo?.DrugScreen.ExpireDate}
                    onClick={isDrugScreenTagClickable(patientInfo?.DrugScreen.Status, isMergedAccount) ? getFile : null}
                  />
                : null}
                {/* Gates itself on the flag and on the patient holding a usable plan, so it
                    sits beside the other status tags with no guard of its own. The row is a
                    plain flex with no gap and `DrugScreenTag` carries no trailing margin, so
                    the 8px is on this side — dropped when the chip is the row's only tag. */}
                <ProgramPlanBadge className='ml-sp-1 first:ml-0' patientId={id} />
                {/* The merged pair's primary account. `DuplicateAccountsSection` says the same
                    thing in a banner further down the chart; this is the at-a-glance version,
                    and it matches the badge on the chart-list row. */}
                {patientInfo?.IsMergedMainAccount ?
                  <Badge size='s' variant={MAIN_ACCOUNT_BADGE.variant} className='ml-sp-1 first:ml-0'>
                    {MAIN_ACCOUNT_BADGE.label}
                  </Badge>
                : null}
              </div>

              <div className='patient-chart-header-info-wrapper'>
                <div>
                  <span className='patient-chart-header-label'>{PREFERRED_NAME_TEXT}:</span>
                  <span className='patient-chart-header-value'>{patientInfo?.PreferredName || '--'}</span>
                </div>
                <div>
                  <span className='patient-chart-header-label'>{MRN_TEXT}:</span>
                  <span className='patient-chart-header-value'>{patientInfo?.MedicalRecordNumber || '--'}</span>
                </div>
                <div>
                  <span className='patient-chart-header-label'>{STATE_TEXT}:</span>
                  <span className='patient-chart-header-value'>
                    {patientInfo?.Address?.StateCode ?
                      getStateByAbbreviation(patientInfo?.Address?.StateCode?.toUpperCase()) || '--'
                    : '--'}
                  </span>
                </div>
                <div>
                  <span className='patient-chart-header-label'>Date of Birth:</span>
                  <span className='patient-chart-header-value'>
                    {patientInfo?.BirthDate ? dateHelper.formatDate(patientInfo?.BirthDate, DATE_FORMAT_SLASH) : '--'}
                  </span>
                </div>
                <div
                  className='patient-chart-header-allergies-wrapper'
                  onMouseLeave={onMouseOutAllergies}
                  onMouseOver={onMouseOverAllergies}
                  onFocus={onMouseOverAllergies}
                  onBlur={onMouseOutAllergies}>
                  {!!allergiesCountValue && (
                    <img className='patient-chart-header-error-icon' src={errorIcon} alt='error-circle' />
                  )}
                  <span className='patient-chart-header-label'>{ALLERGIES_TEXT}:</span>
                  <span className='patient-chart-header-value'>{allergiesCountValue}</span>

                  {!isMergedAccount && (
                    <img
                      role='presentation'
                      className='patient-chart-header-edit-allergies-icon'
                      src={editIcon}
                      alt='edit-allergies'
                      onClick={onClickEditAllergies}
                    />
                  )}

                  {isShowAllergiesHoverOver ?
                    <AllergiesHoverOverPopUp
                      className='patient-chart-header-edit-allergies-hover-over'
                      allergiesList={patientInfo?.AllergyCollection?.Allergies || []}
                    />
                  : null}
                </div>

                {isMergedAccount ?
                  <div>
                    <span className='patient-chart-header-label'>Status:</span>
                    <span className='patient-chart-header-value'>Merged account</span>
                  </div>
                : <div className='patient-chart-header-allergies-wrapper'>
                    {!!isOnHold && (
                      <img className='patient-chart-header-error-icon' src={errorIcon} alt='error-circle' />
                    )}
                    <span className='patient-chart-header-label'>{ON_HOLD_PATIENT_STATUS_TEXT}:</span>
                    <span className='patient-chart-header-value'>{selectedHoldStatus}</span>
                    {isWithOnHoldPermission ?
                      <img
                        role='presentation'
                        className='patient-chart-header-edit-allergies-icon'
                        src={editIcon}
                        alt='edit-on-hold'
                        onClick={onClickEditOnHoldStatus}
                      />
                    : null}
                  </div>
                }
              </div>
            </div>
          </>
        : null}

        {/* PRINT BUTTON */}
        <PrimaryButton
          btnText={PRINT_BUTTON_TEXT}
          additionalPrimaryBtnContainerClassName='patient-chart-header--print-button'
          onPress={onClickPrintBtn}
        />
      </div>
    )
  },
)
